import { cloneCanvas } from "@gameApp/helpers/canvas/cloneCanvas";
import { mergeCanvasLayers } from "@gameApp/helpers/canvas/mergeCanvasLayers";
import { miniGameChatsDrawLayer } from "@gameComponents/MiniGame/Charts/helpers/drawLayer";
import type { Options } from "@gameComponents/MiniGame/Charts/types";

export function miniGameChartsDrawLine(options: Options): void {
  const { xScale, yScale, data, dates, destinationCanvas } = options;

  const isDestinationCanvasValid =
    destinationCanvas instanceof HTMLCanvasElement;

  if (
    !isDestinationCanvasValid ||
    typeof xScale !== "function" ||
    typeof yScale !== "function" ||
    !Array.isArray(data) ||
    !Array.isArray(dates)
  ) {
    return;
  }

  const [layerContext, layerCanvas] = cloneCanvas(destinationCanvas, true);

  miniGameChatsDrawLayer(options, layerContext);
  mergeCanvasLayers(layerCanvas, destinationCanvas);
}
